import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);
  private readonly langKey = 'lang' as const;
  private readonly destroy = new Subject<void>();

  title = 'payment-dev-payee';

  ngOnInit(): void {
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy))
      .subscribe((lang) => {
        document.querySelector('html')?.setAttribute('lang', lang.lang);
      });

    this.translate.addLangs(['hu', 'en']);
    this.translate.setDefaultLang('en');

    const browserLang = this.translate.getBrowserLang();
    const savedLang = localStorage.getItem(this.langKey);

    const usedLang = savedLang || browserLang;
    this.translate.use(
      this.translate.langs.includes(usedLang) ? usedLang : 'en',
    );
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
